<template>
  <section class="page_section__wrap bg-gray-lightest items-center" @scroll="onScroll">
    <div class="max-w-920 w-full wrap-notification-list">
      <div class="flex items-center justify-between p-t-4 p-b-3">
        <h1 class="fz20 fw500">Notifications</h1>
        <router-link class="fz0" to="/notifications/settings">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.15356 4.90013C9.24486 4.21489 9.84864 3.7417 10.5088 3.7417H13.4939C14.1565 3.7417 14.7588 4.21723 14.8504 4.90517L15.0541 6.288C15.217 6.3714 15.3769 6.46214 15.5336 6.55986L16.9054 6.02359L16.9142 6.02041C17.5712 5.78446 18.2631 6.05022 18.5874 6.61837L20.0771 9.12821L20.0813 9.13571C20.4091 9.72159 20.2742 10.4558 19.7345 10.8711L19.7317 10.8732L18.5923 11.7406C18.5963 11.8238 18.5987 11.9105 18.5987 11.9994C18.5987 12.0885 18.5962 12.1752 18.5921 12.2582L19.7305 13.125L19.7343 13.128C20.2689 13.5412 20.4127 14.2733 20.0839 14.8584L20.0801 14.8653L18.5844 17.3876C18.3418 17.8132 17.8824 18.0668 17.4 18.0668C17.2295 18.0668 17.0635 18.0357 16.9066 17.9763L16.8998 17.9737L15.5313 17.4386C15.3735 17.5371 15.215 17.6275 15.055 17.7101L14.8504 19.0999C14.7591 19.786 14.1539 20.2584 13.4946 20.2584H10.5094C9.84516 20.2584 9.2443 19.7819 9.1529 19.0935L8.94921 17.711C8.78657 17.6277 8.62689 17.537 8.47055 17.4395L7.0982 17.976L7.08892 17.9793C6.42726 18.216 5.73994 17.9468 5.4167 17.3813L3.92706 14.8715L3.923 14.8643C3.59487 14.2791 3.72895 13.5451 4.26806 13.129L4.27164 13.1262L5.41131 12.2587C5.4069 12.1706 5.40465 12.0847 5.40465 12.0001C5.40465 11.9156 5.40688 11.8299 5.41128 11.7419L4.26944 10.8725C3.73288 10.4584 3.57819 9.70549 3.93408 9.11578L5.41964 6.61296C5.75133 6.03094 6.48619 5.79376 7.09614 6.02331L7.10422 6.02635L8.47279 6.56153C8.63037 6.46319 8.78887 6.37278 8.94905 6.29021L9.15356 4.90013ZM10.4893 5.09593L10.1779 7.21219L9.83565 7.36232C9.53987 7.49205 9.24346 7.65939 8.93677 7.87203L8.64126 8.07692L6.62054 7.28682C6.61969 7.28664 6.61771 7.28633 6.61449 7.28634C6.60852 7.28635 6.60096 7.28749 6.59337 7.29013C6.59028 7.29121 6.58768 7.29237 6.58564 7.29343L5.09522 9.80443L6.82493 11.1215L6.78457 11.4998C6.76379 11.6945 6.75465 11.8552 6.75465 12.0001C6.75465 12.1448 6.76381 12.3056 6.7846 12.5013L6.82477 12.8794L5.09643 14.195C5.0969 14.1965 5.09762 14.1983 5.09871 14.2006L6.58488 16.7045L6.58868 16.7112C6.58971 16.7131 6.59049 16.7136 6.59183 16.7141C6.5926 16.7144 6.59518 16.7152 6.6005 16.7152C6.60502 16.7153 6.61427 16.7146 6.62856 16.7101L8.64233 15.9229L8.93869 16.1309C9.22666 16.3331 9.52719 16.5029 9.83594 16.6385L10.1779 16.7887L10.4895 18.9039C10.4934 18.9061 10.4999 18.9084 10.5094 18.9084H13.4946C13.5035 18.9084 13.5103 18.9062 13.5147 18.9039L13.826 16.7892L14.1674 16.6388C14.464 16.5082 14.76 16.3412 15.067 16.1282L15.3626 15.9231L17.3862 16.7143C17.3919 16.7163 17.3957 16.7168 17.4 16.7168C17.406 16.7168 17.4112 16.7152 17.4148 16.7133L17.4154 16.7121L18.9078 14.1954L17.178 12.8782L17.2189 12.4995C17.2355 12.3454 17.2487 12.1748 17.2487 11.9994C17.2487 11.8229 17.236 11.6523 17.2191 11.5019L17.1766 11.1216L18.9073 9.80412C18.9069 9.80267 18.9061 9.80079 18.905 9.79852L17.4189 7.2947L17.415 7.28766C17.4148 7.28746 17.4136 7.28635 17.4121 7.28579C17.4107 7.28529 17.4077 7.28439 17.4023 7.28438C17.3977 7.28437 17.389 7.28499 17.3759 7.28914L15.3615 8.07661L15.0651 7.86837C14.7766 7.66566 14.4764 7.49606 14.1683 7.36131L13.8255 7.21138L13.514 5.09646C13.51 5.09416 13.5033 5.0917 13.4939 5.0917H10.5088C10.5 5.0917 10.4936 5.09374 10.4893 5.09593ZM18.916 9.80737L18.9118 9.80985L18.9091 9.80536" fill="#4B4B4B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0012 10.1752C10.9952 10.1752 10.1762 10.9942 10.1762 12.0002C10.1762 13.0061 10.9952 13.8252 12.0012 13.8252C13.0071 13.8252 13.8262 13.0061 13.8262 12.0002C13.8262 10.9942 13.0071 10.1752 12.0012 10.1752ZM8.82617 12.0002C8.82617 10.2487 10.2496 8.8252 12.0012 8.8252C13.7527 8.8252 15.1762 10.2487 15.1762 12.0002C15.1762 13.7517 13.7527 15.1752 12.0012 15.1752C10.2496 15.1752 8.82617 13.7517 8.82617 12.0002Z" fill="#4B4B4B"/></svg>
        </router-link>
      </div>

      <h2 class="text-align-center uppercase fz12 fw500 text-gray-text m-b-3" v-if="getUnRead.length">Unread</h2>
      <notification-item
        v-for="note in getUnRead"
        :key="note.id + 'sadasd'"
        :item="note"
      />
<pre>
<!--  {{getRead}}-->
</pre>
      <h2 class="text-align-center uppercase fz12 fw500 text-gray-text m-y-3" v-if="getRead.length">Read</h2>
      <notification-item
        v-for="note in getRead"
        :key="note.id + 'lll4'"
        :item="note"
      />
      <loader-for-autoload v-if="showLoader"></loader-for-autoload>


      <h2 class="text-align-center fz13 text-gray-text m-t-6 m-b-6" v-if="!next && notes && notes.length && !showLoader">You’ve reached the end of the list</h2>
      <h2 class="text-align-center fz13 text-gray-text m-t-6 m-b-6" v-else-if="!showLoader">There are no notifications yet</h2>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

import notificationItem from '@/components/notifications/notification'
import LoaderForAutoload from "@/components/loader-for-autoload.vue";
export default {
  components: {
    LoaderForAutoload,
    notificationItem
  },
  data() {
    return {
      notes: null,
      timeOut: null,
      readed: false,
      showLoader: false
    }
  },
  computed: {
    ...mapState({
      next: state => state.notifications.next,
      loginData: state => state.confirmation.loginData,
    }),
    getRead() {
      if(!this.notes) return []
      return this.notes.filter(a=> a.notification_type !== 'eventnotification').filter(el => {
        let views = el.views.find(user => user.id == this.loginData.data.user.id)
        return views || this.readed
      })
    },
    getUnRead() {
      if(!this.notes || this.readed) return []
      return this.notes.filter(a=> a.notification_type !== 'eventnotification').filter(el => {
        let views = el.views.find(user => user.id == this.loginData.data.user.id)
        return !views
      })
    },
  },
  methods: {
    ...mapActions(['axiosGetNotifications', 'axiosGetCalendarMembersList']),
    ...mapMutations(['setNotificationDot']),
    async onScroll(e) {
      if(this.next && (e.target.scrollTop + e.target.clientHeight == e.target.scrollHeight)){
        this.showLoader = true
        let result = await this.axiosGetNotifications(this.next)
        this.notes = [...this.notes, ...result]
        this.showLoader = false
      }
    },
    async checkAutoLoad() {
      let element  = document.querySelector('.wrap-notification-list')
      console.log(element)
      console.log(element.clientHeight, document.body.clientHeight)
      if((element.clientHeight + 56) < document.body.clientHeight) {
        this.showLoader = true
        let result = await this.axiosGetNotifications(this.next)
        this.notes = [...this.notes, ...result]
        this.showLoader = false
        this.checkAutoLoad()
      }
    },
  },
  async beforeMount() {
    this.showLoader = true
    this.notes = await this.axiosGetNotifications()
    this.showLoader = false
    this.checkAutoLoad()
  },
  mounted() {
    this.timeOut = setTimeout(() => {
      this.readed = true
      this.setNotificationDot(false)
      clearTimeout(this.timeOut)
    }, 6000);
  },
  beforeDestroy() {
    clearTimeout(this.timeOut)
  }
}
</script>

<style>

</style>